import { useEffect } from "react";

export default function NativeBanner() {
  useEffect(() => {
    const script = document.createElement("script");
    script.async = true;
    script.dataset.cfasync = "false";
    script.src = "//pl27392009.profitablecratecpm.com/f3840776531645137b81150139afef20/invoke.js";
    document.getElementById("container-f3840776531645137b81150139afef20")
      .appendChild(script);
  }, []);

  return (
    <div>
      <div id="container-f3840776531645137b81150139afef20"></div>
    </div>
  );
}
